import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  infoItem: {
    display: 'flex',
    padding: '4px 8px'
  },
  infoTitle: {
    fontSize: theme.textFontSize,
    fontWeight: 400,
    color: theme.dispatchPanelHeaderColor,
    marginRight: 12
  },
  infoValue: {
    fontSize: theme.textFontSize,
    fontWeight: 500,
    color: theme.TextColor,
    wordBreak: 'break-word'
  },
  topSectionItem: {
    flexDirection: 'column'
  },
  highLightValue: {
    fontSize: theme.headerTextFontSize16,
    fontWeight: 500
  }
});
const Details = ({
  title,
  value,
  classes,
  showBoldValue = false,
  isTopSection = false,
  showColon = true
}) => (
  <div className={`${classes.infoItem} ${isTopSection ? classes.topSectionItem : ''}`}>
    <div className={classes.infoTitle}>
      {title}
      {showColon ? ':' : ''}
    </div>
    <div className={`${classes.infoValue} ${showBoldValue ? classes.highLightValue : ''}`}>
      {value}
    </div>
  </div>
);

export default withStyles(styles)(Details);
